import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

export default function() {
	const blockquotesSlider = new Swiper('[data-js=blockquotes-slider]', {
		// configure Swiper to use modules
		modules: [Navigation, Pagination, Autoplay],
		loop: true,
		allowTouchMove: true,
		effect: 'slide',
		spaceBetween: 20,

		autoplay: {
			delay: 5000,
		},

		pagination: {
			el: '.quotes-slider-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '.quotes-slider-button-next',
			prevEl: '.quotes-slider-button-prev',
		},
	});
}